import './App.css';
import React, {useEffect} from 'react';
import Header from './Header'
import Home from './Home'
import Checkout from './Checkout';
import Orders from './Orders';
import Payment from './Payment';
import {BrowserRouter as Router, Switch, Route} from "react-router-dom";
import Login from './Login';
import { auth } from "./firebase";
import { useStateValue } from "./StateProvider";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

const promise = loadStripe(
  "pk_test_51JA9SdSI2L7FoN0IZjV6eEBTna66cZs0BryhKh271aBURt3bslebPvJ0Vusftk85K6HHzY917JwjSYmP9De2EhtQ00Nyhzn468"
);

function App() {
  const [{}, dispatch] = useStateValue();

  useEffect(() => { //listner
    // will only run once when the app component loads
    auth.onAuthStateChanged(authUser => {
      console.log("User Showing",authUser);

      if(authUser)
      {
        dispatch({
          type: "SET_USER",
          user: authUser,
        });
      }
      else{
        dispatch({
          type: "SET_USER",
          user: null,
        });
      }
    })
  },[])

  return (
    <Router>
      <div className="app">
         
        <Switch>
          <Route exact path="/checkout">
          <Header/>
          <Checkout/>
          </Route>
          <Route exact path="/orders">
          <Header/>
          <Orders/>
          </Route>
          <Route path="/login">
            <Login/>
          </Route>
          <Route exact path="/payment">
           <Header/>
           <Elements stripe={promise}> 
            <Payment/>
          </Elements>
          </Route>
          <Route exact path="/">
           <Header/>
            <Home/>
          </Route>
        </Switch>
       
      </div>
    </Router>
  );
}

export default App;
